import { DateAsISOStringType } from "./types/store.types";

type StoreDataSchemaInternal<T> = {
  /**  **Generic Version Number** **/
  v: T;
  /** **Vault Id ** **/
  /** This is populated during loading and after creation.**/
  vid: string;

  /** **Organization Id ** **/
  /** This is populated during loading and after creation. Absent/undefined when the item is not org-owned. **/
  oid?: string;

  /** **Element internal Id** **/
  id: string;
  /** **last Date Modified ** **/
  dm: DateAsISOStringType;
  /** **Date Created** **/
  dc: DateAsISOStringType;

  /** **System Properties that flags model to delete** **/
  del?: boolean;
};

export type StoreData = StoreDataSchemaInternal<number>;

export const DefaultStoreData: StoreData = Object.freeze({
  dc: "",
  dm: "",
  id: "",
  v: 1,
  vid: "",
});

export type StoreDataSchema<S extends number, T = unknown> = StoreDataSchemaInternal<S> & T;
